import request from '@/utils/request'

export function goodsList (data) {
  return request({
    url: 'goods/list',
    method: 'get',
    params: data,
    cancel: true
  })
}

export function adinfo () {
  return request({
    url: 'ad/get-index',
    method: 'get',
  })
}

export function getCategory (data) {
  return request({
    url: 'category/list',
    method: 'get',
    params: data
  })
}

export function getInfo (data) {
  return request({
    url: '/goods/info',
    method: 'get',
    params: data
  })
}
